export default __webpack_public_path__ + "static/media/pause-red.6dba2c70.png";